const PRODUCTION_LINK = "https://gamecraft.nusgdg.org/api";
const LOCAL_LINK = "http://localhost:3001/api";

// npm build will use production env
export const SERVER_LINK = process.env.NODE_ENV === 'production' ? PRODUCTION_LINK : LOCAL_LINK;
